$(document).ready(function () {
  setTimeout(function () {
    $('.yotpo-search-filter.yotpo-free-search-filter-container label').append('<span style="font-size:0;">search reviews</span>');
    $('.yotpo-media-filter.yotpo-media-filter-container label').append('<span style="font-size:0;">with media</span>');
    $('.yotpo-background.yotpo-right-align-background img').attr('alt', 'Refer a Friend Give $25, Get $25 and A woman has been catching a beach sandal.');
    $('a.yotpo-answers-extra').removeAttr('tabindex', '0');
    $('.yotpo-thumbnail-container.yotpo-review-thumbnail-container').removeAttr('role', 'list');
    $('#afterpay-modal').removeAttr('aria-describedby', 'afterpay-modal-container');
    $('svg.u-visually-hidden').attr('aria-hidden','true');
    $('a[target="_blank"]').attr('aria-describedby', 'bbl');
    $('body').prepend('<span id="bbl" style="font-size:0; position: fixed; top:0;" aria-hidden="true">This link open in new tab</span>');
    $('.yotpo-banner-layout.yotpo-banner-low .yotpo-banner-logged-out-text').attr('role','link')
    $('.plyr__progress input').removeAttr('aria-valuemin');
    $('.plyr__progress input').removeAttr('aria-valuemax');
    $('.ImageHero__ImageWrapper .ImageHero__Image').first().attr('aria-label','A collage of pictures of a child and a child');
    $('.ImageHero__ImageWrapper .ImageHero__Image').first().attr('role','img');
    $('.yotpo-background img').removeAttr('aria-hidden');
    jQuery('a[href="https://beek-by-two-birds.returnly.com/"]').attr('aria-describedby','bbl8');
    jQuery('body').prepend('<span id="bbl8" style="font-size:0; width: 0; height: 0px; line-height: 0px; display: flex; top:0;" aria-hidden="true">You will leaving beekshop.com to beek-by-two-birds.returnly.com</span>');
    $('.CollectionFilters #collection-filters-sidebar-form button.Collapsible__Button').attr('role','heading');
    $('.CollectionFilters #collection-filters-sidebar-form button.Collapsible__Button').attr('aria-level','2');
    // $('li.HorizontalList__Item > a.Heading.u-h6').attr('role', 'button');
    // $('li.main-drpdwn > a').attr('aria-expanded', 'false');
    // $("li.HorizontalList__Item a[href='/collections/womens-leather-sandals']").first().removeAttr('href');
    // $("li.HorizontalList__Item a[href='/collections/shoes']").first().removeAttr('href');
    // $("li.HorizontalList__Item a[href='/pages/about']").first().removeAttr('href');
}, 3000);
}, 3000);
$('button.Faq__Question,button.collapsible').click(function (e) {
  e.preventDefault();
  $(this).attr('aria-expanded', function (i, attr) {
    return attr == 'true' ? 'false' : 'true'
  });
});
$("button.collapsible").click(function () {
  $(".content").attr('aria-hidden', function (i, attr) {
    return attr == 'false' ? 'true' : 'false'
  });
});
// Collapse_button_js_start
var coll = document.getElementsByClassName("collapsible");
var i;

for (i = 0; i < coll.length; i++) {
  coll[i].addEventListener("click", function () {
    this.classList.toggle("active");
    var content = this.nextElementSibling;
    if (content.style.maxHeight) {
      content.style.maxHeight = null;
    } else {
      content.style.maxHeight = content.scrollHeight + "px";
    }
  });
}
// Collapse_button_js_end
// $( "button.Faq__Question" ).click(function() {
//     $( this ).attr('aria-expanded','true');
//   });


// nav-on-click
// $(document).ready(function () {

//   // NAV ONCLICK
//   // $("li.HorizontalList__Item .MegaMenu").hide();
//   $("li.HorizontalList__Item").click(function () {
//     // $(this).children(".MegaMenu").stop(true, true).slideToggle("fast"),
//     //   $(this).closest(".a").stop(true, true).slideToggle("fast"),
//     // $(this).toggleClass("hmw");
//     $(this).toggleClass("hmw"),
//     $(this).siblings().removeClass("hmw");
//     $(this).find('a.Heading').attr('aria-expanded', function (i, attr) {
//       return attr == 'true' ? 'false' : 'true'
//     });
    
//   });
  
// });
// nav-on-end

jQuery('.SectionHeader.SectionHeader--center h2').each(function () {
  const $this = jQuery(this);
  if ($this.html().replace(/\s|&nbsp;/g, '').length === 0)
    $this.remove();
});

var intervalID = window.setInterval(myCallback, 50);
function myCallback() {
  var textAreaCheck = document.getElementsByClassName('g-recaptcha-response');
  if (textAreaCheck.length > 0) {
    jQuery(textAreaCheck).attr('aria-label', 'g-recaptcha-response');
    console.log(jQuery(textAreaCheck));
    clearInterval(intervalID);
  }
}